// Ring buffer global des dernieres erreurs/warnings console + erreurs runtime.
// Initialise une seule fois au demarrage (main.js). Lu par le module de rapport admin.

const MAX_ENTRIES = 20;
const buffer = [];
let installed = false;

function serialize(arg) {
  if (arg instanceof Error) return arg.stack || arg.message;
  if (typeof arg === 'object' && arg !== null) {
    try { return JSON.stringify(arg); } catch { return String(arg); }
  }
  return String(arg);
}

function push(level, args) {
  try {
    const message = args.map(serialize).join(' ').slice(0, 2000); // borne chaque message
    buffer.push({ level, message, at: Date.now() });
    if (buffer.length > MAX_ENTRIES) buffer.shift();
  } catch {
    /* ne jamais casser l'app a cause du buffer */
  }
}

export function initConsoleBuffer() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const origError = console.error.bind(console);
  const origWarn = console.warn.bind(console);

  console.error = (...args) => { push('error', args); origError(...args); };
  console.warn = (...args) => { push('warn', args); origWarn(...args); };

  window.addEventListener('error', (e) => {
    push('error', [e.message, `${e.filename}:${e.lineno}`]);
  });
  window.addEventListener('unhandledrejection', (e) => {
    push('error', ['Unhandled rejection:', e.reason]);
  });
}

export function getConsoleErrors() {
  return buffer.slice();
}
